export default {
    API_URL: '/api/'
}